import { css } from '@emotion/css'
import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { observer } from 'mobx-react'
import React, { Dispatch, FC, SetStateAction, useState } from 'react'
import { useIntl } from 'react-intl'
import InputField from '../../../../../../components/customElements/InputField/InputField'
import CustomAccordion from '../../../../../../components/customElements/RequestDataAccordions/utils/CustomAccordion'
import { getStyles } from '../../../../../../utils/utils/commonUtils'
import requestsManagementStyles from '../../../../styles/requestsManagementStyles'
import DealerCard from './DealerCard'

const NewDealerSelect: FC<{
  dealer: string
  setDealer: Dispatch<SetStateAction<string>>
  collection: any[]
  availableRequestData?: Record<string, number[]>
}> = ({ dealer, setDealer, collection, availableRequestData }) => {
  const intl = useIntl()
  const classes = getStyles(requestsManagementStyles)

  const [search, setSearch] = useState('')

  const filteredDealers = collection.filter((el: any) =>
    el.displayName.toLowerCase().includes(search.toLowerCase())
  )

  return (
    <>
      <Box mx={-2}>
        {/* @ts-ignore */}
        <CustomAccordion
          defaultOpenState={true}
          summary={intl.formatMessage({ id: 'Назначить на дилера' })}
        >
          <Box
            sx={{
              marginY: '10px',
            }}
          >
            <InputField
              value={search}
              onChange={(e: any) => setSearch(e.target.value)}
              onPaste={(e: any) => setSearch(e.target.value)}
              label={'Имя'}
              territorySelect={false}
              type='text'
              fullWidth
            />
          </Box>

          {filteredDealers.length ? (
            <Stack
              spacing={1}
              // @ts-ignore
              className={css(classes.dealersScrollContainer)}
              style={{ minHeight: dealer ? '36vh' : '45vh' }}
            >
              {filteredDealers.map((dealerItem: any) => (
                <DealerCard
                  key={dealerItem.subjectId}
                  dealer={dealerItem}
                  selected={dealer === dealerItem.subjectId}
                  onSelect={() => setDealer(dealerItem.subjectId)}
                  onlyShow={false}
                  requestsCount={
                    availableRequestData?.[dealerItem.subjectId]?.length
                  }
                />
              ))}
            </Stack>
          ) : (
            <Stack
              justifyContent={'center'}
              alignItems={'center'}
              width={'100%'}
              height={'100%'}
              pt={2}
            >
              <Typography variant={'body1'}>
                Подходящие дилеры не найдены
              </Typography>
            </Stack>
          )}
        </CustomAccordion>
      </Box>
    </>
  )
}

export default observer(NewDealerSelect)
